import React, { useEffect } from 'react';
import Chart from 'chart.js/auto';
import Masonry from 'masonry-layout';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import Moment from 'moment';
import { Card, CardHeader, CardBody } from './../../components/card/card.jsx';
import 'bootstrap-daterangepicker/daterangepicker.css';
import { getChartJsDefaultOptions } from './../../composables/chartOptions.js';

function Analytics() {
	var chart1 = '';
	var chart2 = '';
	var chart3 = '';
	var chart4 = '';
	var chart5 = '';
		
	var dateRange = {
		currentWeek: Moment().subtract(7, 'days').format('D MMM YYYY') + ' - ' + Moment().format('D MMM YYYY'),
		prevWeek: Moment().subtract(15, 'days').format('D MMM') + ' - ' + Moment().subtract(8, 'days').format('D MMM YYYY')
	};
	
	var startDate = '';
	var endDate = '';
	var prevDay = Moment().add(-1, 'd').format('D MMM YYYY');
	var nextDay = Moment().add(0, 'd').format('D MMM YYYY');
	
		
	function handleDateApplyEvent(event, picker) {
		var startDate = picker.startDate;
		var endDate = picker.endDate;
		var gap = endDate.diff(startDate, 'days');
		
		var currentWeek = startDate.format('D MMM YYYY') + ' - ' + endDate.format('D MMM YYYY');
		var prevWeek = Moment(startDate).subtract(gap, 'days').format('D MMM') + ' - ' + Moment(startDate).subtract(1, 'days').format('D MMM YYYY');
		
		dateRange.currentWeek = currentWeek;
		dateRange.prevWeek = prevWeek;
	}
	
	function renderChart() {
		function newDate(days) {
			return Moment().add(days, 'd').format('D MMM');
		}
		
		// color & font variable
		var gray300Color = (getComputedStyle(document.body).getPropertyValue('--bs-gray-300')).trim();
		var gray300RgbColor = (getComputedStyle(document.body).getPropertyValue('--bs-gray-300-rgb')).trim();
		var indigoColor = (getComputedStyle(document.body).getPropertyValue('--bs-indigo')).trim();
		var bodyBg = (getComputedStyle(document.body).getPropertyValue('--bs-body-bg')).trim();
		var themeColor = (getComputedStyle(document.body).getPropertyValue('--bs-theme')).trim();
		
		// chart 1
		var chart1Container = document.getElementById('chart-1');
		if (chart1) {
			chart1.destroy();
		}
		if (chart1Container) {
			chart1Container.innerHTML = '<canvas id="chart1" className="w-100" height="190"></canvas>';
			chart1 = new Chart(document.getElementById('chart1').getContext('2d'), {
				type: 'line',
				data: {
					labels: ['', '4am', '8am', '12pm', '4pm', '8pm', newDate(1)],
					datasets: [{
						color: themeColor,
						backgroundColor: 'transparent',
						borderColor: themeColor,
						borderWidth: 2,
						pointBackgroundColor: bodyBg,
						pointBorderWidth: 2,
						pointRadius: 4,
						pointHoverBackgroundColor: bodyBg,
						pointHoverBorderColor: themeColor,
						pointHoverRadius: 6,
						pointHoverBorderWidth: 2,
						data: [0, 0, 0, 601.5, 220]
					},{
						color: gray300Color,
						backgroundColor: 'rgba('+ gray300RgbColor + ', .2)',
						borderColor: gray300Color,
						borderWidth: 2,
						pointBackgroundColor: bodyBg,
						pointBorderWidth: 2,
						pointRadius: 4,
						pointHoverBackgroundColor: bodyBg,
						pointHoverBorderColor: gray300Color,
						pointHoverRadius: 6,
						pointHoverBorderWidth: 2,
						data: [0, 0, 0, 500, 120, 0, 0, 0]
					}]
				},
				options: {
					maintainAspectRatio: false
				}
			});
		}
		
		// #chart2
		var chart2Container = document.getElementById('chart-2');
		if (chart2) {
			chart2.destroy();
		}
		if (chart2Container) {
			chart2Container.innerHTML = '<canvas id="chart2" className="w-100" height="190"></canvas>';
			chart2 = new Chart(document.getElementById('chart2').getContext('2d'), {
				type: 'line',
				data: {
					labels: ['', '4am', '8am', '12pm', '4pm', '8pm', newDate(1)],
					datasets: [{
						color: themeColor,
						backgroundColor: 'transparent',
						borderColor: themeColor,
						borderWidth: 2,
						pointBackgroundColor: bodyBg,
						pointBorderWidth: 2,
						pointRadius: 4,
						pointHoverBackgroundColor: bodyBg,
						pointHoverBorderColor: themeColor,
						pointHoverRadius: 6,
						pointHoverBorderWidth: 2,
						data: [0, 20, 50, 100, 120]
					},{
						color: gray300Color,
						backgroundColor: 'rgba('+ gray300RgbColor + ', .2)',
						borderColor: gray300Color,
						borderWidth: 2,
						pointBackgroundColor: bodyBg,
						pointBorderWidth: 2,
						pointRadius: 4,
						pointHoverBackgroundColor: bodyBg,
						pointHoverBorderColor: gray300Color,
						pointHoverRadius: 6,
						pointHoverBorderWidth: 2,
						data: [0, 30, 44, 130, 34, 15, 43, 22]
					}]
				},
				options: {
					maintainAspectRatio: false
				}
			});
		}

		// #chart3
		var chart3Container = document.getElementById('chart-3');
		if (chart3) {
			chart3.destroy();
		}
		if (chart3Container) {
			chart3Container.innerHTML = '<canvas id="chart3" className="w-100" height="190"></canvas>';
			chart3 = new Chart(document.getElementById('chart3').getContext('2d'), {
				type: 'line',
				data: {
					labels: ['', '4am', '8am', '12pm', '4pm', '8pm', newDate(1)],
					datasets: [{
						color: indigoColor,
						backgroundColor: 'transparent',
						borderColor: indigoColor,
						borderWidth: 2,
						pointBackgroundColor: bodyBg,
						pointBorderWidth: 2,
						pointRadius: 4,
						pointHoverBackgroundColor: bodyBg,
						pointHoverBorderColor: indigoColor,
						pointHoverRadius: 6,
						pointHoverBorderWidth: 2,
						data: [0, 0, 5, 18, 9]
					},{
						color: themeColor,
						backgroundColor: 'rgba('+ themeColor +', .2)',
						borderColor: themeColor,
						borderWidth: 2,
						pointBackgroundColor: bodyBg,
						pointBorderWidth: 2,
						pointRadius: 4,
						pointHoverBackgroundColor: bodyBg,
						pointHoverBorderColor: themeColor,
						pointHoverRadius: 6,
						pointHoverBorderWidth: 2,
						data: [0, 0, 10, 26, 13]
					}]
				},
				options: {
					maintainAspectRatio: false
				}
			});
		}

		// #chart4
		var chart4Container = document.getElementById('chart-4');
		if (chart4) {
			chart4.destroy();
		}
		if (chart4Container) {
			chart4Container.innerHTML = '<canvas id="chart4" className="w-100" height="190"></canvas>';
			chart4 = new Chart(document.getElementById('chart4').getContext('2d'), {
				type: 'line',
				data: {
					labels: ['', '4am', '8am', '12pm', '4pm', '8pm', newDate(1)],
					datasets: [{
						color: themeColor,
						backgroundColor: 'transparent',
						borderColor: themeColor,
						borderWidth: 2,
						pointBackgroundColor: bodyBg,
						pointBorderWidth: 2,
						pointRadius: 4,
						pointHoverBackgroundColor: bodyBg,
						pointHoverBorderColor: themeColor,
						pointHoverRadius: 6,
						pointHoverBorderWidth: 2,
						data: [0, 0, 0, 24, 39]
					},{
						color: gray300Color,
						backgroundColor: 'rgba('+ gray300RgbColor + ', .2)',
						borderColor: gray300Color,
						borderWidth: 2,
						pointBackgroundColor: bodyBg,
						pointBorderWidth: 2,
						pointRadius: 4,
						pointHoverBackgroundColor: bodyBg,
						pointHoverBorderColor: gray300Color,
						pointHoverRadius: 6,
						pointHoverBorderWidth: 2,
						data: [0, 0, 0, 28, 35, 23, 0, 0]
					}]
				},
				options: {
					maintainAspectRatio: false
				}
			});
		}
	
		// #chart5
		var chart5Container = document.getElementById('chart-5');
		if (chart5) {
			chart5.destroy();
		}
		if (chart5Container) {
			chart5Container.innerHTML = '<canvas id="chart5" className="w-100" height="190"></canvas>';
			chart5 = new Chart(document.getElementById('chart5').getContext('2d'), {
				type: 'line',
				data: {
					labels: ['', '4am', '8am', '12pm', '4pm', '8pm', newDate(1)],
					datasets: [{
						color: themeColor,
						backgroundColor: 'transparent',
						borderColor: themeColor,
						borderWidth: 2,
						pointBackgroundColor: bodyBg,
						pointBorderWidth: 2,
						pointRadius: 4,
						pointHoverBackgroundColor: bodyBg,
						pointHoverBorderColor: themeColor,
						pointHoverRadius: 6,
						pointHoverBorderWidth: 2,
						data: [0, 0, 0, 12, 5]
					},{
						color: gray300Color,
						backgroundColor: 'rgba('+ gray300RgbColor + ', .2)',
						borderColor: gray300Color,
						borderWidth: 2,
						pointBackgroundColor: bodyBg,
						pointBorderWidth: 2,
						pointRadius: 4,
						pointHoverBackgroundColor: bodyBg,
						pointHoverBorderColor: gray300Color,
						pointHoverRadius: 6,
						pointHoverBorderWidth: 2,
						data: [0, 0, 0, 10, 4, 2, 0, 0]
					}]
				},
				options: {
					maintainAspectRatio: false
				}
			});
		}
	}
	
	useEffect(() => {
		getChartJsDefaultOptions();
		
		renderChart();
		new Masonry('[data-masonry]');
		
		document.addEventListener('theme-reload', () => {
			renderChart();
		});
	});
	
	return (
		<div>
			<h1 className="page-header">
				Analytics <small>stats, overview & performance</small>
			</h1>
			
			<div className="d-flex align-items-center mb-3">
				<DateRangePicker startDate={startDate} endDate={endDate} onApply={handleDateApplyEvent}>
					<a href="#/" className="btn btn-secondary btn-sm d-inline-flex align-items-center">
						<span>{dateRange.currentWeek}</span>
						<i className="fa fa-chevron-down ms-2 fs-8px"></i>
					</a>
				</DateRangePicker>
				<div className="ms-3 small">compared to <span>{dateRange.prevWeek}</span></div>
			</div>
			
			<div className="row g-3" data-masonry='{"percentPosition": true }'>
				<div className="col-sm-6 col-xl-4">
					<Card>
						<CardHeader className="d-flex">
							TOTAL SALES <span className="ms-auto"><a href="#/" className="text-decoration-none">VIEW REPORT</a></span>
						</CardHeader>
						<CardBody>
							<div className="d-flex align-items-center h3 mb-0">
								<div>$821.50</div>
								<small className="fw-400 ms-auto text-success">+5%</small>
							</div>
							<hr />
							<div>
								<div className="fs-10px fw-semibold mb-3">SALES OVER TIME</div>
								<div className="chart mb-2" style={{height: '190px'}}>
									<div id="chart-1"></div>
								</div>
								<div className="d-flex align-items-center justify-content-center">
									<i className="fa fa-square text-gray-300 me-2"></i> 
									<span className="fs-10px fw-semibold me-4">{ prevDay }</span>
									<i className="fa fa-square text-theme me-2"></i> 
									<span className="fs-10px fw-semibold">{ nextDay }</span>
								</div>
							</div>
						</CardBody>
					</Card>
				</div>
				
				<div className="col-sm-6 col-xl-4">
					<Card>
						<CardHeader className="d-flex">
							ONLINE STORE SESSIONS <span className="ms-auto"><a href="#/" className="text-decoration-none">VIEW REPORT</a></span>
						</CardHeader>
						<CardBody>
							<div className="d-flex align-items-center h3 mb-0">
								<div>1,239</div>
								<small className="fw-400 ms-auto text-danger">-2.5%</small>
							</div>
							<hr />
							<div className="row mb-2">
								<div className="col-6">Returning Visitors</div>
								<div className="col-3 text-center">242</div>
								<div className="col-3 text-end">
									<span className="text-danger">-</span> 14.0%
								</div>
							</div>
							<div className="row">
								<div className="col-6">New Visitors</div>
								<div className="col-3 text-center">829</div>
								<div className="col-3 text-end">
									<span className="text-success">+</span> 18.3%
								</div>
							</div>
							<hr />
							<div className="fs-10px fw-semibold mb-3">SESSIONS OVER TIME</div>
							<div className="chart mb-2" style={{height: '190px'}}>
								<div id="chart-2"></div>
							</div>
							<div className="d-flex align-items-center justify-content-center">
								<i className="fa fa-square text-gray-300 me-2"></i> 
								<span className="fs-10px fw-semibold me-4">{ prevDay }</span>
								<i className="fa fa-square text-theme me-2"></i> 
								<span className="fs-10px fw-semibold">{ nextDay }</span>
							</div>
						</CardBody>
					</Card>
				</div>
				
				<div className="col-sm-6 col-xl-4">
					<Card>
						<CardHeader className="d-flex">
							TOP PRODUCT BY UNITS SOLD
						</CardHeader>
						<CardBody>
							<div className="row mb-2">
								<div className="col-6">iPhone 11 Pro Max</div>
								<div className="col-3 text-center">329</div>
								<div className="col-3 text-end"><span className="text-success">+</span> 5.0%</div>
							</div>
							<div className="row mb-2">
								<div className="col-6">iPad Pro</div>
								<div className="col-3 text-center">219</div>
								<div className="col-3 text-end"><span className="text-danger">-</span> 5.2%</div>
							</div>
							<div className="row mb-2">
								<div className="col-6">Macbook Pro</div>
								<div className="col-3 text-center">125</div>
								<div className="col-3 text-end"><span className="text-success">+</span> 2.3%</div>
							</div>
							<div className="row mb-2">
								<div className="col-6">iPhone SE 2</div>
								<div className="col-3 text-center">92</div>
								<div className="col-3 text-end"><span className="text-success">+</span> 4.9%</div>
							</div>
							<div className="row mb-2">
								<div className="col-6">Apple pencil</div>
								<div className="col-3 text-center">52</div>
								<div className="col-3 text-end"><span className="text-success">+</span> 5.2%</div>
							</div>
						</CardBody>
					</Card>
				</div>
				
				<div className="col-sm-6 col-xl-4">
					<Card>
						<CardHeader className="d-flex">
							RETURNING CUSTOMER RATE
						</CardHeader>
						<CardBody>
							<div className="d-flex align-items-center h3 mb-0">
								<div>52.85%</div>
								<small className="fw-400 ms-auto text-danger">-7%</small>
							</div>
							<hr />
							<div>
								<div className="fs-10px fw-semibold mb-3">CUSTOMERS</div>
								<div className="chart mb-2" style={{height: '190px'}}>
									<div id="chart-3"></div>
								</div>
								<div className="d-flex align-items-center justify-content-center">
									<i className="fa fa-square text-gray-300 me-2"></i> 
									<span className="fs-10px fw-semibold me-4">First-time</span>
									<i className="fa fa-square text-theme me-2"></i> 
									<span className="fs-10px fw-semibold">Returning</span>
								</div>
							</div>
						</CardBody>
					</Card>
				</div>
				
				<div className="col-sm-6 col-xl-4">
					<Card>
						<CardHeader className="d-flex">
							CONVERSION RATE <span className="ms-auto"><a href="#/" className="text-decoration-none">VIEW REPORT</a></span>
						</CardHeader>
						<CardBody>
							<div className="d-flex align-items-center h3 mb-0">
								<div>5.29%</div>
								<small className="fw-400 ms-auto text-success">+83%</small>
							</div>
							<hr />
							<div className="row mb-2">
								<div className="col-6">
									<div className="text-white fw-semibold">Added to cart</div>
									<div className="text-white text-opacity-50 small">55 session</div>
								</div>
								<div className="col-3 text-center">25.28%</div>
								<div className="col-3 text-end"><span className="text-danger">-</span> 5.0%</div>
							</div>
							<div className="row mb-2">
								<div className="col-6">
									<div className="text-white fw-semibold">Reached checkout</div>
									<div className="text-white text-opacity-50 small">25 session</div>
								</div>
								<div className="col-3 text-center">15.28%</div>
								<div className="col-3 text-end"><span className="text-success">+</span> 8.2%</div>
							</div>
							<div className="row">
								<div className="col-6">
									<div className="text-white fw-semibold">Sessions converted</div>
									<div className="text-white text-opacity-50 small">5 session</div>
								</div>
								<div className="col-3 text-center">5.28%</div>
								<div className="col-3 text-end"><span className="text-success">+</span> 8.2%</div>
							</div>
						</CardBody>
					</Card>
				</div>
				
				<div className="col-sm-6 col-xl-4">
					<Card>
						<CardHeader className="d-flex">
							AVERAGE ORDER VALUE
						</CardHeader>
						<CardBody>
							<div className="d-flex align-items-center h3 mb-0">
								<div>$35.12</div>
								<small className="fw-400 ms-auto text-danger">-3.2%</small>
							</div>
							<hr />
							<div>
								<div className="fs-10px fw-semibold mb-3">ORDERS OVER TIME</div>
								<div className="chart mb-2" style={{height: '190px'}}>
									<div id="chart-4"></div>
								</div>
								<div className="d-flex align-items-center justify-content-center">
									<i className="fa fa-square text-gray-300 me-2"></i> 
									<span className="fs-10px fw-semibold me-4">{ prevDay }</span>
									<i className="fa fa-square text-theme me-2"></i> 
									<span className="fs-10px fw-semibold">{ nextDay }</span>
								</div>
							</div>
						</CardBody>
					</Card>
				</div>
				
				<div className="col-sm-6 col-xl-4">
					<Card>
						<CardHeader className="d-flex">
							TOTAL ORDERS
						</CardHeader>
						<CardBody>
							<div className="d-flex align-items-center h3 mb-0">
								<div>12</div>
								<small className="fw-400 ms-auto text-success">+57%</small>
							</div>
							<hr />
							<div>
								<div className="fs-10px fw-semibold mb-3">ORDERS OVER TIME</div>
								<div className="chart mb-2">
									<div id="chart-5"></div>
								</div>
								<div className="d-flex align-items-center justify-content-center">
									<i className="fa fa-square text-gray-300 me-2"></i> 
									<span className="fs-10px fw-semibold me-4">{ prevDay }</span>
									<i className="fa fa-square text-theme me-2"></i> 
									<span className="fs-10px fw-semibold">{ nextDay }</span>
								</div>
							</div>
						</CardBody>
					</Card>
				</div>
				
				<div className="col-sm-6 col-xl-4">
					<Card>
						<CardHeader className="d-flex">
							TOP PAGES BY SESSIONS
						</CardHeader>
						<CardBody>
							<div className="row mb-2">
								<div className="col-6"><div><a href="#/" className="text-decoration-none">/phone/apple-15-pro-max</a></div></div>
								<div className="col-3 text-center">15</div>
								<div className="col-3 text-end"><span className="text-success">+</span> 9.0%</div>
							</div>
							<div className="row mb-2">
								<div className="col-6"><div><a href="#/" className="text-decoration-none">/tablet/apple-ipad-pro-128gb</a></div></div>
								<div className="col-3 text-center">12</div>
								<div className="col-3 text-end"><span className="text-success">+</span> 8.0%</div>
							</div>
							<div className="row">
								<div className="col-6"><div><a href="#/" className="text-decoration-none">/desktop/apple-mac-pro</a></div></div>
								<div className="col-3 text-center">4</div>
								<div className="col-3 text-end"><span className="text-danger">-</span> 3.0%</div>
							</div>
						</CardBody>
					</Card>
				</div>
				
				<div className="col-sm-6 col-xl-4">
					<Card>
						<CardHeader className="d-flex">
							SESSIONS BY DEVICE TYPE <span className="ms-auto"><a href="#/" className="text-decoration-none">VIEW REPORT</a></span>
						</CardHeader>
						<CardBody>
							<div className="row mb-2">
								<div className="col-6">
									<div>Desktop</div>
								</div>
								<div className="col-3 text-center">247</div>
								<div className="col-3 text-end"><span className="text-success">+</span> 4.2%</div>
							</div>
							<div className="row mb-2">
								<div className="col-6">
									<div>Mobile</div>
								</div>
								<div className="col-3 text-center">198</div>
								<div className="col-3 text-end"><span className="text-danger">-</span> 2.2%</div>
							</div>
							<div className="row mb-2">
								<div className="col-6">
									<div>Tablet</div>
								</div>
								<div className="col-3 text-center">35</div>
								<div className="col-3 text-end"><span className="text-success">+</span> 8.9%</div>
							</div>
							<div className="row mb-2">
								<div className="col-6">
									<div>Smart TV</div>
								</div>
								<div className="col-3 text-center">17</div>
								<div className="col-3 text-end"><span className="text-success">+</span> 2.9%</div>
							</div>
							<div className="row">
								<div className="col-6">
									<div>Smart Watch</div>
								</div>
								<div className="col-3 text-center">5</div>
								<div className="col-3 text-end"><span className="text-success">+</span> 0.9%</div>
							</div>
						</CardBody>
					</Card>
				</div>
				
				<div className="col-sm-6 col-xl-4">
					<Card>
						<CardHeader className="d-flex">
							VISITS FROM SOCIAL SOURCES <span className="ms-auto"><a href="#/" className="text-decoration-none">VIEW REPORT</a></span>
						</CardHeader>
						<CardBody>
							<div className="row mb-2">
								<div className="col-6">
									<div>Facebook</div>
								</div>
								<div className="col-3 text-center">247</div>
								<div className="col-3 text-end"><span className="text-success">+</span> 4.2%</div>
							</div>
							<div className="row mb-2">
								<div className="col-6">
									<div>Twitter</div>
								</div>
								<div className="col-3 text-center">153</div>
								<div className="col-3 text-end"><span className="text-success">+</span> 8.2%</div>
							</div>
							<div className="row mb-2">
								<div className="col-6">
									<div>Instagram</div>
								</div>
								<div className="col-3 text-center">98</div>
								<div className="col-3 text-end"><span className="text-danger">-</span> 3.4%</div>
							</div>
							<div className="row mb-2">
								<div className="col-6">
									<div>Pinterest</div>
								</div>
								<div className="col-3 text-center">75</div>
								<div className="col-3 text-end"><span className="text-success">+</span> 1.9%</div>
							</div>
							<div className="row">
								<div className="col-6">
									<div>Dribbble</div>
								</div>
								<div className="col-3 text-center">22</div>
								<div className="col-3 text-end"><span className="text-success">+</span> 2.1%</div>
							</div>
						</CardBody>
					</Card>
				</div>
			</div>
		</div>
	)
}

export default Analytics;